import styled from 'styled-components';

const EmptyState = styled.div`
  color: #888;
  font-size: 14px;
  padding: 20px;
`;

export default EmptyState;
